<template>
  <div>
    <cart-steps step="payment" />

    <!-- If I have a payment url -->
    <redirect-to-payment-service
      v-if="paymentUrl"
      :payment-url="paymentUrl"
    />

    <!-- If I have juste a purchase reference without payment url (free purchase by exemple) -->
    <order-confirmation
      v-if="purchaseReference"
      :purchase-reference="purchaseReference"
    />
  </div>
</template>

<script>
import CartSteps from "./partial/cart/CartSteps";
import RedirectToPaymentService from "@/components/partial/cart/payment/RedirectToPaymentService";
import OrderConfirmation from "@/components/partial/cart/payment/OrderConfirmation";

export default {
  name: "CartPayment",
  components: { OrderConfirmation, RedirectToPaymentService, CartSteps },

  data() {
    return {
      paymentUrl: "",
      purchaseReference: ""
    };
  },

  beforeMount() {
    let urlParams = new URLSearchParams(window.location.search);
    this.paymentUrl = urlParams.get("payment-url");
    this.purchaseReference = urlParams.get("purchase-reference");
  }
};
</script>
<style lang="scss" src="../assets/styles/buefy/base.scss"></style>
